<template>
  <MaisButtonStatusIcon
    :show-icon="isSessionActive"
    icon="check"
  >
    <div class="relative z-10">
      <PButton
        class="elevation-3 flex size-10 items-center justify-center rounded-full bg-red-300"
        :class="isSessionActive ? 'bg-white' : 'bg-red-300'"
        :disabled="isSessionActive || inProgress"
        @click="uziLogin"
      >
        <img
          src="/images/zorg-id.svg"
          alt="zorgId"
          class="h-3/5 translate-x-px translate-y-[2px]"
        >
      </PButton>
    </div>
  </MaisButtonStatusIcon>

  <Dialog
    v-model:visible="inProgress"
    :header="$t('zorgId.dialogHeader')"
    modal
  >
    {{ $t('zorgId.dialogText') }}
  </Dialog>
</template>

<script lang="ts" setup>
const { inProgress, isSessionActive, uziLogin } = useZorgId()
</script>
